import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M10.969 13.031v-8.25a1.03 1.03 0 1 1 2.062 0v8.25a1.03 1.03 0 1 1-2.062 0zm-.206 5.982A1.237 1.237 0 1 1 12 20.25h-.002a1.234 1.234 0 0 1-1.234-1.234v-.002z"
}), 'Exclam');